import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnDestroy {
  currentUrl = '';

  private subscription = new Subscription();

  constructor(private readonly router: Router) {
    this.subscription.add(
      router.events.subscribe((navigation) => {
        if (navigation instanceof NavigationEnd) {
          this.currentUrl = navigation.url;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
